import { useState } from 'react'
import cloneDeep from 'lodash/cloneDeep'

interface Image {
  thumbnail_url: string
  public_id: string
  secure_url: string
}

const useImageUpload = () => {
  const [uploadedImages, setUploadedImages] = useState<Image[]>([])
  const [base64Images, setBase64Images] = useState<string[]>([])

  const onOpenClick = (e: any) => {
    const selectedFiles = Array.from(e.target.files)
    // Ensure a maximum of 4 images can be uploaded
    if (selectedFiles.length + uploadedImages.length > 4) {
      alert('You can upload up to 4 images only.')
      return
    }

    const imageUrls = selectedFiles.map(file =>
      URL.createObjectURL(file as Blob)
    )

    if (selectedFiles) {
      // Convert each file to Base64
      const promises: Promise<string>[] = selectedFiles.map(file => {
        return new Promise<string>((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => {
            if (typeof reader.result === 'string') {
              resolve(reader.result) // Base64 string
            } else {
              reject(new Error('File reading resulted in a non-string result.'))
            }
          }
          reader.onerror = () => reject(new Error('Error reading file.'))
          reader.readAsDataURL(file as Blob) // Convert file to Base64
        })
      })

      // Wait for all Base64 conversions to complete
      Promise.all(promises)
        .then(base64Array => {
          setBase64Images(prevImages => [...prevImages, ...base64Array])
        })
        .catch(error => {
          console.error('Error converting files to Base64:', error)
        })
    }

    // @ts-ignore
    setUploadedImages(prevImages => [...prevImages, ...imageUrls])
  }

  return {
    open: onOpenClick,
    uploadedImages,
    base64Images,
    resetImages: () => {
      setUploadedImages([])
      setBase64Images([])
    },
    removeImage: (index: number) => {
      setUploadedImages(state => {
        const newState = cloneDeep(state)
        newState.splice(index, 1)
        return newState
      })
    }
  }
}

export default useImageUpload
